import MacPage from '@/components/Pages/MacPage';

export default MacPage;
